import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/Shared/Common/common.service';
import { PropertyPostsService } from 'src/app/Shared/PostRequests/property-posts.service';

declare var $: any;

@Component({
  selector: 'app-report-frauds',
  templateUrl: './report-frauds.component.html',
  styleUrls: ['./report-frauds.component.css']
})
export class ReportFraudsComponent implements OnInit {

  @Input() PostId: string = '';
  @Input() PortalType: string = 'Mobile';
  authData: any;
  fraudsForm: FormGroup;
  fraudList: any[] = [];

  constructor(private fraudsfb: FormBuilder, private fraudsCommonService: CommonService
    , private fraudsRouter: Router, private fraudsPostsService: PropertyPostsService) {

  }

  ngOnInit() {
    this.LoadReportFraudInfo();
    this.authData = localStorage.getItem('authData') == undefined ? '' : JSON.parse(localStorage.getItem('authData'));
    if (this.authData == '') {
      this.fraudsCommonService.CallToster('E', 'Invalid user authencation, Please re-login...!');
      $('.model').modal('hide');
      setTimeout(() => {
        $(".modal-backdrop").removeClass("show");
        if (this.PortalType == 'Mobile')
          this.fraudsRouter.navigateByUrl('/m/');
        else
          this.fraudsRouter.navigateByUrl('/');
      }, 2000);
    }

    this.fraudsForm = this.fraudsfb.group({
      RequestID: [0],
      UserID: [0],
      ReportFraudTypeID: ['', [Validators.required]],
      Remarks: ['', [Validators.required]]
    });

  }

  LoadReportFraudInfo() {
    try {
      this.fraudsPostsService.GetAllReportFraudInfo().subscribe(res => {
        if (res.status == 1) {
          this.fraudList = res.body;
        }
      }, err => {

      });
    } catch (error) {

    }

  }

  doSaveReportFraudsDetails() {
    try {
      if (this.fraudsForm.valid) {
        this.fraudsForm.controls['RequestID'].setValue(this.PostId);
        this.fraudsForm.controls['UserID'].setValue(this.authData.UserID);
        //console.log(JSON.stringify(this.fraudsForm.value));
        this.fraudsPostsService.InsertPropertyReport(this.fraudsForm.value).subscribe(res => {
          //console.log(res);
          if (res.body == -1) {
            this.fraudsCommonService.CallToster('E', 'Apologies, but it appears that you are limited to one report per day.');
          } else {
            this.fraudsCommonService.CallToster('S', 'Your report has been successfully submitted. Our team will review it and get back to you shortly.');
            setTimeout(() => {
              $('.modal').modal('hide');
            }, 2000);
          }
        }, err => {
          this.fraudsCommonService.CallToster('E', 'Invalid details entry, Please try again later...!');
        });
      }
      else {
        this.fraudsCommonService.CallToster('E', 'Invalid details entry, Please try again later...!');
      }

    } catch (error) {
      this.fraudsCommonService.CallToster('E', 'Invalid details entry, Please try again later...!');
    }
  }

}
